var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEventImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_3576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 269C216.274 269 270 215.274 270 149C270 82.7258 216.274 29 150 29C83.7258 29 30 82.7258 30 149C30 215.274 83.7258 269 150 269Z",
    fill: "url(#paint0_linear_722_3576)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_3576)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.0001,
    y: 63.5566,
    width: 124.537,
    height: 155.029,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 83.5566,
    width: 50,
    height: 9.8,
    rx: 4.9,
    fill: "#011625"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 111.356,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 139.156,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 166.957,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 194.757,
    width: 100,
    height: 9.8,
    rx: 4.9,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_722_3576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.15 46.4238H228.069C225.27 46.4238 223 48.8123 223 51.7587V81.4778C223 84.4242 225.27 86.8127 228.069 86.8127H288.15C290.95 86.8127 293.219 84.4242 293.219 81.4778V51.7587C293.219 48.8123 290.95 46.4238 288.15 46.4238Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238 73C241.314 73 244 70.3137 244 67C244 63.6863 241.314 61 238 61C234.686 61 232 63.6863 232 67C232 70.3137 234.686 73 238 73Z",
    fill: "#CCC6D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 61,
    width: 32,
    height: 12,
    rx: 6,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.11 225.563C197.99 225.563 209.959 221.667 219.905 214.99L260.605 253.841L275.365 236.716L236.092 199.226C243.345 189.018 247.61 176.539 247.61 163.063C247.61 128.546 219.627 100.563 185.11 100.563C150.592 100.563 122.61 128.546 122.61 163.063C122.61 197.581 150.592 225.563 185.11 225.563ZM238.419 163.064C238.419 192.287 214.729 215.977 185.505 215.977C156.282 215.977 132.592 192.287 132.592 163.064C132.592 133.84 156.282 110.15 185.505 110.15C214.729 110.15 238.419 133.84 238.419 163.064Z",
    fill: "#CCC6D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_722_3576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.5 217C215.6 217 240 192.823 240 163C240 133.177 215.6 109 185.5 109C155.4 109 131 133.177 131 163C131 192.823 155.4 217 185.5 217Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.923 163L208.112 149.862C209.348 148.562 210.025 146.835 209.999 145.047C209.974 143.259 209.248 141.552 207.976 140.287C206.704 139.023 204.986 138.301 203.187 138.276C201.388 138.251 199.65 138.923 198.342 140.151L185.124 153.289L171.935 140.151C171.3 139.484 170.537 138.95 169.691 138.58C168.845 138.211 167.933 138.014 167.009 138.001C166.085 137.988 165.168 138.159 164.312 138.504C163.456 138.85 162.678 139.362 162.024 140.012C161.371 140.661 160.855 141.434 160.508 142.285C160.16 143.136 159.988 144.048 160.001 144.967C160.014 145.885 160.212 146.791 160.584 147.632C160.955 148.473 161.493 149.231 162.165 149.862L175.376 163L162.165 176.138C161.493 176.769 160.955 177.527 160.584 178.368C160.212 179.209 160.014 180.115 160.001 181.033C159.988 181.952 160.16 182.863 160.508 183.715C160.855 184.566 161.371 185.339 162.024 185.988C162.678 186.637 163.456 187.15 164.312 187.496C165.168 187.841 166.085 188.012 167.009 187.999C167.933 187.986 168.845 187.789 169.691 187.42C170.537 187.05 171.3 186.516 171.935 185.849L185.153 172.711L198.372 185.849C199.692 187.004 201.405 187.616 203.164 187.559C204.922 187.503 206.592 186.782 207.834 185.544C209.076 184.305 209.796 182.643 209.848 180.896C209.9 179.148 209.279 177.446 208.112 176.138L194.923 163Z",
    fill: "#FF4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.602 253.843L275.362 236.718L277.585 238.84C279.742 240.899 281.033 243.775 281.175 246.837C281.317 249.898 280.297 252.893 278.341 255.163C276.384 257.433 273.651 258.792 270.742 258.941C267.833 259.091 264.987 258.018 262.83 255.959L260.607 253.836L260.602 253.843Z",
    fill: "#E1DCEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3144 91.1719C56.2956 89.7459 56.1167 88.3076 55.7589 86.8594C54.5042 81.7773 48.9064 78.5146 42.9484 77.7475C36.9927 76.9804 30.7993 78.7261 28.4123 83.1468C27.047 85.6743 26.8587 87.8527 27.4166 89.6893C27.9721 91.5161 29.2903 93.0306 31.0793 94.2108C36.0675 97.4981 44.8034 98.1693 48.7887 96.7949C50.6319 96.1581 52.4327 95.391 54.1864 94.5133C53.1836 100.259 49.4477 105.703 44.4619 110.608C33.6264 121.269 16.8117 129.36 7.65456 132.335C7.16257 132.495 6.88948 133.041 7.04249 133.554C7.19551 134.068 7.71809 134.356 8.21008 134.196C17.5485 131.162 34.6905 122.899 45.7402 112.026C51.4487 106.411 55.5164 100.09 56.2109 93.4437C69.1156 86.2423 79.7134 73.1769 88.774 62.1817C89.1106 61.776 89.0659 61.1589 88.6751 60.8073C88.2844 60.4582 87.6958 60.5024 87.3592 60.9106C78.6681 71.4558 68.5812 84 56.3144 91.1719ZM54.4383 92.2169C54.509 90.6138 54.3582 88.9861 53.951 87.3437C52.8658 82.9452 47.8776 80.3439 42.72 79.6801C39.5585 79.2744 36.3077 79.6088 33.7583 80.7988C32.1552 81.5462 30.8345 82.6305 30.0389 84.1057C28.9937 86.0407 28.7677 87.6954 29.1961 89.0993C29.6245 90.513 30.6887 91.6489 32.0752 92.561C36.6208 95.5582 44.575 96.195 48.2025 94.9435C50.3423 94.2059 52.4186 93.2864 54.4383 92.2169Z",
    fill: "#011625"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 184,
    r: 6,
    fill: "#417BA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3845 225.394C59.4553 224.993 60.582 224.459 61.451 223.686C62.483 222.769 62.9027 221.587 63.1845 220.343C63.5464 218.744 63.6909 217.042 64.1297 215.441C64.2922 214.846 64.6048 214.621 64.739 214.522C65.0781 214.27 65.4208 214.202 65.7433 214.228C66.1254 214.257 66.6504 214.409 66.9956 215.083C67.0448 215.18 67.1088 215.327 67.1519 215.528C67.1833 215.676 67.2036 216.137 67.2368 216.328C67.3199 216.797 67.3894 217.266 67.4546 217.737C67.6719 219.306 67.7968 220.639 68.483 222.081C69.414 224.038 70.347 225.235 71.6122 225.766C72.8356 226.279 74.2984 226.182 76.1673 225.78C76.3451 225.735 76.5211 225.696 76.6953 225.664C77.5193 225.513 78.307 226.082 78.4688 226.946C78.6307 227.809 78.107 228.65 77.2904 228.84C77.1199 228.88 76.9519 228.917 76.7857 228.952C74.2602 229.61 71.3365 231.958 69.6374 234.014C69.1137 234.648 68.347 236.421 67.5648 237.551C66.9876 238.386 66.339 238.935 65.7943 239.13C65.4294 239.261 65.1217 239.24 64.8676 239.174C64.4984 239.079 64.1919 238.868 63.9568 238.533C63.8288 238.35 63.71 238.104 63.6534 237.791C63.6263 237.64 63.6233 237.257 63.6239 237.083C63.4645 236.506 63.2694 235.943 63.1273 235.36C62.7882 233.971 62.123 233.092 61.3328 231.93C60.5937 230.843 59.7999 230.159 58.6362 229.614C58.4848 229.575 57.2633 229.26 56.8319 229.08C56.2017 228.815 55.9014 228.371 55.7925 228.132C55.6073 227.727 55.5882 227.373 55.6251 227.077C55.6799 226.641 55.8657 226.268 56.1956 225.967C56.3999 225.78 56.7051 225.598 57.1137 225.509C57.4294 225.44 58.2669 225.4 58.3845 225.394ZM65.5506 223.13C65.6073 223.263 65.6676 223.396 65.7316 223.531C67.0953 226.397 68.6202 227.998 70.4737 228.774L70.5359 228.799C69.2959 229.768 68.1734 230.851 67.3156 231.889C66.9623 232.317 66.4947 233.205 65.9894 234.115C65.5303 232.545 64.7796 231.435 63.8356 230.045C63.1143 228.985 62.3587 228.187 61.43 227.537C62.1507 227.148 62.838 226.692 63.4368 226.16C64.4337 225.273 65.0928 224.246 65.5506 223.13Z",
    fill: "#417BA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_3576",
    x: 59.0001,
    y: 53.5566,
    width: 184.537,
    height: 215.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_3576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_3576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_722_3576",
    x: 216,
    y: 37.4238,
    width: 96.219,
    height: 66.3887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_3576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_3576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_722_3576",
    x: 123,
    y: 101,
    width: 125,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_722_3576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_722_3576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_3576",
    x1: 149.075,
    y1: -10.0749,
    x2: 151.533,
    y2: 411.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_3576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEventImage);
export default __webpack_public_path__ + "static/media/noEventImage.3e07def09a93ca5a37170ab6179c4d3e.svg";
export { ForwardRef as ReactComponent };